export const addLeadingZero = (number: number): string => {
  return number < 10 ? `0${number}` : `${number}`;
};

export const formatDate = (date: Date, format: string): string => {
  const map: any = {
    mm: addLeadingZero(date.getMonth() + 1),
    dd: addLeadingZero(date.getDate()),
    yy: date.getFullYear().toString().slice(-2),
    Y: date.getFullYear(),
    hh: addLeadingZero(date.getHours()),
    ii: addLeadingZero(date.getMinutes()),
    ss: addLeadingZero(date.getSeconds()),
  };

  return format.replace(/mm|dd|yy|Y|hh|ii|ss/gi, (matched: string) => map[matched] || '');
};

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};

const getDays = (year: number, month: number): number => {
  return new Date(year, month, 0).getDate();
};

export const getDaysInCurrentMonth = () => {
  const currentDate = new Date();
  return getDays(currentDate.getFullYear(), currentDate.getMonth() + 1);
};

export const getLeaveYears = (): number[] => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const isFirstHalf = currentMonth < 10;

  if (isFirstHalf) {
    return [-4, -3, -2, -1, 0];
  }
  return [-3, -2, -1, 0, 1];
};
